import type { RefObject } from "react";
import type { KeyboardActionId } from "~/keyboard/actionCatalog";

import shouldSubmitOnEnter from "~/helpers/shouldSubmitOnEnter";
import useShortcut from "~/keyboard/useShortcut";

const useEnterSubmit = (
	actionId: KeyboardActionId,
	onSubmit: () => void,
	enabled = true,
	rootRef?: RefObject<Element | null>
) => {
	useShortcut(
		actionId,
		(event) => {
			if (!shouldSubmitOnEnter(event, document, rootRef?.current)) return;
			onSubmit();
			return true;
		},
		{ enabled }
	);
};

export default useEnterSubmit;
